import classNames from 'classnames';
import React from 'react';
import { FaSortUp, FaSortDown } from 'react-icons/fa';

type SortIconProps = {
  isSorted?: boolean
  isAscending?: boolean
  isDescending?: boolean
};

function SortIcon( {
  isSorted, isAscending, isDescending,
}: SortIconProps ) {
  return (
    <span style={{ marginLeft: 5 }}>
      <FaSortUp className={classNames( {
        'text--gray2': !isSorted || isDescending,
      } )}
      />

      <FaSortDown
        className={classNames( {
          'text--gray2': !isSorted || isAscending,
        } )}
        style={{ marginLeft: -16 }}
      />
    </span>
  );
}

export default SortIcon;
